import { AcceptorLoginResponse } from '@/interfaces/acceptor-login-response.interface';
import { AgreementResponse } from '@/interfaces/agreement-response.interface';
import { AddOrRemove, FetchCache } from '@/utils/local-storage-cache.util';
import { ActionContext, createStore, Store } from 'vuex';

export interface AcceptorAccountVuex {
    account: AcceptorLoginResponse | undefined;
}
const SS_ACCOUNT_KEY = 'acceptor_account';
const cache = (store: Store<AcceptorAccountVuex>) => {
    store.subscribe((mutation, state: AcceptorAccountVuex) => {
        switch (mutation.type) {
            case 'setAccount':
                AddOrRemove(SS_ACCOUNT_KEY, state.account, 'sessionStorage');
                break;
            default: break;
        }
    });
};

export const AcceptorAccountStore: Store<AcceptorAccountVuex> = createStore({
    state: {
        account: FetchCache(SS_ACCOUNT_KEY, 'sessionStorage'),
    },
    mutations: {
        setAccount(state: AcceptorAccountVuex, account: AcceptorLoginResponse | undefined) {
            state.account = account;
        },
    },
    actions: {
        updateAccount(context: ActionContext<AcceptorAccountVuex, AcceptorAccountVuex>, acceptorAccount: AcceptorLoginResponse) {
            acceptorAccount.tokenTimestamp = new Date().getTime();
            context.commit('setAccount', acceptorAccount);
        },
        async logout(context: ActionContext<AcceptorAccountVuex, AcceptorAccountVuex>) {
            context.commit('setAccount');
            sessionStorage.clear();
        }
    },
    getters: {
        Role: (state: AcceptorAccountVuex) => (): string | undefined => {
            return state.account?.role;
        },
        Token: (state: AcceptorAccountVuex) => (): string | undefined => {
            return state.account?.token;
        },
        TokenTimestamp: (state: AcceptorAccountVuex) => (): number | undefined => {
            return state.account?.tokenTimestamp;
        },
        Name: (state: AcceptorAccountVuex) => (): string | undefined => {
            return `${state.account?.acceptor.firstName} ${state.account?.acceptor.surname}`;
        },
        OfferorName: (state: AcceptorAccountVuex) => (): string | undefined => {
            return state.account?.offeror.name;
        },
        AcceptedOffers: (state: AcceptorAccountVuex) => (): AgreementResponse[] | undefined => {
            return state.account?.acceptor.agreements.sort((a, b) => Number(new Date(a.createdDate)) - Number(new Date(b.createdDate)));
        },
    },
    plugins: [cache]
});
